import { DataTable } from "pages/gdt/layout/DataTable";
import { useToolEditorContext } from "components/ToolEditor/Provider/ToolEditorProvider";
import { CallOutError } from "components/CallOutError/CallOutError";
import {
  EuiCallOut,
  EuiFlexGroup,
  EuiFlexItem,
  EuiSpacer,
} from "@inscopix/ideas-eui";
import { ButtonCreateTestTable } from "../../components/ButtonCreateTestTable";
import { ModalProvider } from "providers/ModalProvider/ModalProvider";
import { DataTableTooltipProvider } from "pages/gdt/layout/DataTableTooltip";
import { DataTableQuickActionBar } from "pages/gdt/layout/DataTableQuickActionBar/DataTableQuickActionBar";
import { DataTableSyncStatusBadge } from "pages/gdt/layout/DataTableSyncStatusBadge";
import { ToolEditorLoading } from "components/ToolEditor/components/ToolEditorLoading";
import { ProjectPermissionProvider } from "pages/project/ProjectPermissionProvider";

export const ToolEditorFormTest = () => {
  const testTable = useToolEditorContext((s) => s.testTable);

  const isDraftSpecSynced = useToolEditorContext((s) => s.isDraftSpecSynced);
  const projectId = useToolEditorContext((s) => s.project.id);
  const resetDataTableProviderKey = useToolEditorContext(
    (s) => s.resetDataTableProviderKey,
  );

  const onRefresh = () => resetDataTableProviderKey();

  if (testTable === null) {
    return <CallOutError />;
  }

  return (
    <ProjectPermissionProvider
      projectId={projectId}
      LoadingComponent={ToolEditorLoading}
    >
      <EuiFlexGroup direction="column" style={{ height: 0 }}>
        {!isDraftSpecSynced && (
          <EuiFlexItem grow={false}>
            <EuiCallOut
              color="warning"
              iconType="warning"
              title="Your table is out of sync with your draft spec."
            >
              You have made changes to your draft spec and this table is now out
              of date. To see the latest changes on this table, please generate
              a new table.
              <EuiSpacer size="s" />
              <ButtonCreateTestTable />
            </EuiCallOut>
          </EuiFlexItem>
        )}
        <EuiFlexItem grow style={{ minHeight: 300 }}>
          <ModalProvider>
            <DataTableTooltipProvider>
              <EuiFlexGroup gutterSize="xl">
                <EuiFlexItem>
                  <DataTableQuickActionBar hasNotes={false} />
                </EuiFlexItem>
                <EuiFlexItem grow={false}>
                  <DataTableSyncStatusBadge onRefresh={onRefresh} />
                </EuiFlexItem>
              </EuiFlexGroup>
              <DataTable suppressHeaderMenus suppressReorderCols />
            </DataTableTooltipProvider>
          </ModalProvider>
        </EuiFlexItem>
      </EuiFlexGroup>
    </ProjectPermissionProvider>
  );
};
